<template>
  <div class="flex flex-col border rounded-lg shadow p-3">
    <div class="flex  shrink-0 flex-col mt-2 gap-1">
      <label class="text-surface-500 text-sm" for="title">Názov</label>
      <InputText id="title" v-model="state.name" size="small"/>
    </div>

    <div class="flex  shrink-0 flex-col mt-2 gap-1">
      <label class="text-surface-500 text-sm" for="title">Title</label>
      <InputText id="title" v-model="state.title" size="small"/>
    </div>

    <div class="flex  shrink-0 flex-col mt-2 gap-1">
      <label class="text-surface-500 text-sm" for="title">Sub title</label>
      <InputText id="title" v-model="state.subTitle" size="small"/>
    </div>

    <div class="my-2">
      Pložky
    </div>

    <div class="mt-2">

      <template v-for="(_,i) in state.items" :key="i +  '-' + state.items[i].appProductId">
        <b class="text-surface-500 mt-2 text-sm">Vyberte Produkt</b>
        <MySelect v-model="state.items[i].appProductId"
                  :options="products"
                  placeholder="Vyberte produkt"
                  class="w-full mt-1"
                  :filter="true"
        />
        <div class="flex justify-end mt-2">
          <Button @click="removeOption(i)" size="small" label="Odstraniť" class=""/>
        </div>
      </template>

      <hr class="my-2">

      <div class="w-full">
        <Button @click="addNewOption" size="small" label="Pridať" class=""/>
      </div>

      <hr class="my-4">

      <Button @click="save" :disabled="deleting" :loading="loading" size="small" label="Uložiť" class="w-full"/>

      <hr class="my-2">

      <Button @click="deleteAction" :loading="deleting" :disabled="loading" size="small" label="Zmazať" class="w-full"/>

    </div>
  </div>
</template>

<script setup>
import {computed, ref, reactive} from "vue"
import MySelect from "@/components/inputs/MySelect.vue"
import useContentStore from "@/stores/contentStore.js"
import Supabase from "@/utils/Supabase.js"
import {useToast} from "primevue/usetoast";
import {useConfirm} from "primevue/useconfirm";

const props = defineProps({
  restaurantPlace: {
    type: String,
    required: true
  },
  data: {
    type: Object,
    required: true
  }
})

const originalItemsId = computed(() => (props.data.items ?? []).map(item => item.id).filter(item => item !== null))

const toast = useToast();
const confirm = useConfirm();

const contentStore = useContentStore()
const products = computed(() => contentStore.appProductsList[props.restaurantPlace].map(item => ({
  title: item.title,
  value: item.id
})))

const state = ref({...props.data})

const addNewOption = () => state.value.items.push({id: null})
const removeOption = (index) => {
  if (!window.confirm('Naozaj chcete odstrániť túto položku?')) return
  // state.value.items = state.value.items.splice(index, 1)
  state.value.items = state.value.items.filter((_, i) => i !== index)

}

const loading = ref(false)
const save = async () => {

  loading.value = true

  const saveData = {
    name: state.value.name,
    title: state.value.title,
    subTitle: state.value.subTitle,
    restaurantPlace: props.restaurantPlace
  }

  if (props.data.id) saveData.id = props.data.id
  const {data, error} = await Supabase.from('v2_Hajcer_App_Products_Extra').upsert(saveData).select().single()

  if (error) {
    toast.add({severity: 'error', summary: 'Error', detail: error.message, life: 3000});
    loading.value = false
    return
  }

  const insertedId = data.id

  console.log(insertedId, 'insertedId')

  const {
    data: deleteData,
    error: errorDelete
  } = await Supabase.from('v2_Hajcer_App_Products_Extra_Products').delete().eq('productExtraId', insertedId)

  if (errorDelete) {
    toast.add({severity: 'error', summary: 'Error', detail: errorDelete.message, life: 3000});
    loading.value = false
    return
  }

  const mappedItems = state.value.items.map((item, index) => {
    const data = {
      order: index,
      restaurantPlace: props.restaurantPlace,
      productExtraId: insertedId,
      appProductId: item.appProductId
    }
    return data
  })

  console.log(mappedItems, 'mappedItems')

  const {
    error: errorProducts_Extra_Products
  } = await Supabase.from('v2_Hajcer_App_Products_Extra_Products').insert(mappedItems).select()

  // const newIds = upsertItemsData.map(item => item.id)

  if (errorProducts_Extra_Products) {
    toast.add({severity: 'error', summary: 'Error', detail: errorProducts_Extra_Products.message, life: 3000});
    loading.value = false
    return
  }

  // const idsToDelete = originalItemsId.value.filter(id => !newIds.includes(id)).filter(id => !!id)
  // if (idsToDelete.length > 0) {
  //   const {
  //     data: deleteData,
  //     error: errorDelete
  //   } = await Supabase.from('v2_Hajcer_App_Products_Extra_Products').delete().in('id', idsToDelete).select()
  //
  //   if (errorDelete) {
  //     toast.add({severity: 'error', summary: 'Error', detail: errorDelete.message, life: 3000});
  //     loading.value = false
  //     return
  //   }
  // }

  await contentStore.loadMealExtras()
  toast.add({severity: 'success', summary: 'Úspešne', detail: 'Položka bola uložená', life: 3000});
  loading.value = false


}

const deleting = ref(false)
const deleteAction = () => {
  confirm.require({
    message: 'Naozaj chcete zmazať túto položku?',
    accept: async () => {

      deleting.value = true
      const {
        error: errorDelete
      } = await Supabase.from('v2_Hajcer_App_Products_Extra_Products').delete().match({
        productExtraId: state.value.id,
        restaurantPlace: props.restaurantPlace
      })

      if (errorDelete) {
        toast.add({severity: 'error', summary: 'Error', detail: error.message, life: 3000});
        return
      }

      const {
        data,
        error
      } = await Supabase.from('v2_Hajcer_App_Products_Extra').delete().eq('id', state.value.id).select()
      if (error) {
        toast.add({severity: 'error', summary: 'Error', detail: error.message, life: 3000});
        return
      }
      deleting.value = false
      toast.add({severity: 'success', summary: 'Úspešne', detail: 'Položka bola zmazaná', life: 3000});
      await contentStore.loadMealExtras()
    }
  })
}


</script>